<template>
  <b-container fluid class="mt-4">
    <b-btn :click="payAll">Run Auto Pay</b-btn>
    <b-form>
      <!--      <b-row class="mb-2">-->
      <!--        <b-col>-->
      <!--          {{ $t('Choose a date range') }}:-->
      <!--          <date-range-picker-->
      <!--            :showDropdowns="true"-->
      <!--            ref="picker"-->
      <!--            v-model="dateRange"-->
      <!--            @update="submit"-->
      <!--            opens="right"-->
      <!--            :autoApply="true"-->
      <!--            :ranges="ranges"-->
      <!--            :linked-calendars="false"-->
      <!--          >-->
      <!--&lt;!&ndash;            <template v-slot:input="picker" style="min-width: 350px;">&ndash;&gt;-->
      <!--&lt;!&ndash;              {{ picker.startDate | date }} - {{ picker.endDate | date }}&ndash;&gt;-->
      <!--&lt;!&ndash;            </template>&ndash;&gt;-->
      <!--          </date-range-picker>-->
      <!--        </b-col>-->
      <!--      </b-row>-->
      <!--      <b-row class="mb-2">-->
      <!--        <b-col>-->
      <!--          <b-btn @click="submit">Submit</b-btn>-->
      <!--        </b-col>-->
      <!--      </b-row>-->
    </b-form>
    <!--    <p>{{ $t('Total') }}: {{ async.total }} </p>-->
    <!--    <p>{{ $t('Unpaid') }}: {{ async.unpaidTotal }}</p>-->
    <!--    <p>{{ $t('Paid') }}: {{ async.paidTotal }}</p>-->
    <!--    <p>{{ $t('Profit Total') }}: {{ async.profitTotal }}</p>-->

    <b-table responsive :items="items"></b-table>
  </b-container>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  name: "Orders",
  components: { DateRangePicker },
  data() {
    const ranges = {};
    const monthNow = new Date().getMonth();
    for (let i = -1; i < 6; i++) {
      const currentMonth = monthNow - i;

      const nextMonthObj = new Date(new Date().getFullYear(), currentMonth, 0);
      const currentMonthObj = new Date(
        new Date().getFullYear(),
        currentMonth - 1,
        1
      );

      const monthName = currentMonthObj.toLocaleString("default", {
        month: "short",
      });
      ranges[monthName] = [currentMonthObj, nextMonthObj];
    }

    return {
      ranges,
      dateRange: {
        startDate: new Date(Date.now() - 30 * 86400 * 1000),
        endDate: new Date(),
      },
      form: {},
      items: [],
      async: {
        orders: [],
        unpaidTotal: 0,
      },
    };
  },
  methods: {
    payAll() {
      this.$post("/pay-all");
    },
    makeRanges() {},
    async submit() {
      this.items = await this.$get("/billing", {
        params: { ...this.form, ...this.dateRange },
      });
    },
    async init() {
      this.submit();
    },
  },
  watch: {
    currentPage(newPage) {
      console.log(newPage);
      this.$router.push({
        params: { page: newPage },
        query: this.$route.query,
      });
      this.init();
    },
    $route: "init",
  },
  async created() {
    this.init();
  },
};
</script>
<style scoped>
input {
  margin-top: 5px;
}

.manage-data {
  width: 19%;
  display: inline;
  margin-right: 1%;
}
</style>
